// @ts-check

/**
 * @typedef {import('./PixStrategy').PixStrategy} PixStrategy
 */

/**
 * Mercado Pago Pix strategy.
 * @function MercadoPagoPixStrategy
 * @returns {PixStrategy}
 */
const MercadoPagoPixStrategy = () => {
  const needsRedirect = false;

  /**
   * Creates a token for Pix payment.
   * @returns {Promise<string>} The created token.
   */
  const createToken = async () => {
    // Mercado Pago does not need to create a token in order to process a Pix payment
    return '';
  };

  return {
    needsRedirect,
    createToken,
  };
};

const mercadoPagoPixStrategy = MercadoPagoPixStrategy();

export default mercadoPagoPixStrategy;
